import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

// antd
import {
    Layout,
    Card,
    Image,
    Row,
    Col,
    Typography,
    Avatar,
    Popover,
    Space,
    Divider,
    message,
    theme,
} from 'antd'
import { LogoutOutlined } from '@ant-design/icons'

// constants
import { loginState, isLoggedInLogin, signOut } from '../login/login.slice'
import {
    DOMAIN_LIST,
    SUPER_ADMIN,
    WORKSPACE_ADMIN,
} from '../../constants/roles'

// routes
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from '../../routes'

// helpers
import { checkSettingModule } from '../../helpers/settingsModuleCheck'

// assets
import { SettingsIcon, BackIcon } from '../../assets/icons'
import { svgCompnyeLogoFull } from '../../assets/svg'

// components
import DeletePopUp from '../../components/deletePopUp/deletePopUp'

// css
import styles from '../../layouts/layouts.module.css'

const { Header, Content } = Layout
const { Title, Text } = Typography

const initialState = {
    openProfile: false,
    deleteModal: false,
    deleteButtonLoading: false,
}

function GlobalSetting() {
    const { useToken } = theme
    const { token } = useToken()

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { userProfile, socketClient } = useSelector(loginState)
    const [state, setState] = useState(initialState)

    const handleOpenProfile = (newOpen) => {
        setState({ ...state, openProfile: newOpen })
    }

    // LOGOUT
    const logOut = async () => {
        const result = await dispatch(signOut())
        const data = result?.payload?.data
        if (data) {
            const { success, message: logOutMessage } = data
            if (success) {
                localStorage.removeItem('token')
                sessionStorage.removeItem('token')
                if (Object.keys(socketClient).length !== 0) {
                    socketClient.disconnect()
                }
                setState({ ...state, deleteButtonLoading: false })
                message.success(logOutMessage)
                const result = await dispatch(isLoggedInLogin())

                const data = result?.payload?.data
                if (data) {
                    const { success } = data
                    if (!success) {
                        navigate(PUBLIC_ROUTES.login)
                        window.localStorage.clear()
                    }
                }
            } else {
                setState({ ...state, deleteButtonLoading: false })

                message.error('Something went wrong, try again later.')
            }
        }
    }

    const shouldShowHeader =
        userProfile?.role?.roleName === SUPER_ADMIN &&
        DOMAIN_LIST.includes(userProfile?.currentWorkSpace?.domain)

    return (
        <Layout style={{ minHeight: '100vh', backgroundColor: '#fff' }}>
            {/* Header */}
            {shouldShowHeader && (
                <Header
                    style={{
                        background: '#fff',
                        padding: '0 25px 0px 30px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '1px solid #dedede',
                    }}
                >
                    <Row style={{ gap: '20px' }} align={'middle'}>
                        <img
                            src={svgCompnyeLogoFull}
                            alt="Company Logo"
                            width={160}
                        />
                    </Row>
                    <Row style={{ gap: '20px' }} align={'middle'}>
                        <div
                            style={{
                                height: '34px',
                                width: '34px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                navigate(PRIVATE_ROUTES.globalSettings.root)
                            }}
                        >
                            <SettingsIcon
                                color={token.colorPalette.baseColor.black}
                            />
                        </div>
                        <Popover
                            overlayInnerStyle={{
                                padding: 0,
                            }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                            open={state?.openProfile}
                            onOpenChange={handleOpenProfile}
                            content={
                                <>
                                    <Row
                                        style={{
                                            padding: 12,
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => {
                                            if (
                                                userProfile?.role?.roleName !==
                                                    SUPER_ADMIN &&
                                                userProfile?.role?.roleName !==
                                                    WORKSPACE_ADMIN &&
                                                DOMAIN_LIST.includes(
                                                    userProfile
                                                        ?.currentWorkSpace
                                                        ?.domain
                                                )
                                            ) {
                                                setState({
                                                    ...state,
                                                    openProfile: false,
                                                })
                                                navigate(PRIVATE_ROUTES.profile)
                                            }
                                        }}
                                    >
                                        <Space size={'middle'}>
                                            <Col>
                                                {userProfile?.profilePicture ? (
                                                    <>
                                                        <Image
                                                            src={
                                                                userProfile?.profilePicture
                                                            }
                                                            height={40}
                                                            width={40}
                                                            rootClassName="headerImage"
                                                            style={{
                                                                borderRadius:
                                                                    '50%',

                                                                cursor: 'pointer',
                                                            }}
                                                            preview={false}
                                                        />
                                                    </>
                                                ) : (
                                                    <Avatar
                                                        size={'large'}
                                                        style={{
                                                            backgroundColor:
                                                                'rgb(0 10 129 / 25%)',
                                                        }}
                                                    >
                                                        {userProfile?.name
                                                            ? `${userProfile?.name[0].toUpperCase()}${
                                                                  userProfile?.name.split(
                                                                      ' '
                                                                  )[1] !==
                                                                  undefined
                                                                      ? userProfile?.name
                                                                            .split(
                                                                                ' '
                                                                            )[1][0]
                                                                            .toUpperCase()
                                                                      : ''
                                                              }`
                                                            : ''}
                                                    </Avatar>
                                                )}
                                            </Col>
                                            <Col>
                                                <Row>
                                                    <Text>
                                                        {userProfile?.name}
                                                    </Text>
                                                    &nbsp;
                                                    <Text
                                                        style={{
                                                            textTransform:
                                                                'capitalize',
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        (
                                                        {
                                                            userProfile?.role
                                                                ?.roleName
                                                        }
                                                        )
                                                    </Text>
                                                </Row>
                                                <Text
                                                    style={{
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    {userProfile?.email}
                                                </Text>
                                            </Col>
                                        </Space>
                                    </Row>
                                    <Divider
                                        style={{
                                            margin: 0,
                                        }}
                                    />
                                    <div
                                        style={{
                                            padding: '5px',
                                        }}
                                        onClick={() => {
                                            setState({
                                                ...state,
                                                openProfile: false,
                                                deleteModal: true,
                                            })
                                        }}
                                    >
                                        <div className={styles.logoutCard}>
                                            <Row
                                                align={'middle'}
                                                style={{
                                                    gap: 10,
                                                }}
                                            >
                                                <LogoutOutlined
                                                    style={{
                                                        fontSize: '19px',
                                                    }}
                                                />
                                                <Text
                                                    style={{
                                                        fontSize: '15px',
                                                    }}
                                                >
                                                    Log out
                                                </Text>
                                            </Row>
                                        </div>
                                    </div>
                                </>
                            }
                            trigger="click"
                            arrow={false}
                            placement="bottomLeft"
                        >
                            {userProfile?.profilePicture ? (
                                <Image
                                    src={userProfile?.profilePicture}
                                    height={36}
                                    className="headerImage"
                                    width={36}
                                    style={{
                                        borderRadius: '50%',
                                        verticalAlign: 'baseline !important',
                                        cursor: 'pointer',
                                    }}
                                    preview={false}
                                />
                            ) : (
                                <Avatar
                                    size={'large'}
                                    style={{
                                        cursor: 'pointer',
                                        backgroundColor: 'rgb(0 10 129 / 25%)',
                                    }}
                                >
                                    {userProfile?.name[0].toUpperCase()}
                                    {userProfile?.name.split(' ')[1] !==
                                        undefined &&
                                        userProfile?.name
                                            .split(' ')[1][0]
                                            .toUpperCase()}
                                </Avatar>
                            )}
                        </Popover>
                    </Row>
                </Header>
            )}

            {/* Main Content */}
            <Content
                style={{
                    padding: '35px',
                }}
            >
                {/* Back Icon and Title Section */}
                <Row
                    align={'middle'}
                    justify={'space-between'}
                    style={{
                        marginBottom: '30px',
                    }}
                >
                    <Row
                        align={'middle'}
                        style={{
                            columnGap: '13px',
                        }}
                    >
                        <SettingsIcon
                            color={token.colorPalette.baseColor.tertiary}
                        />
                        <Title level={4} style={{ margin: 0 }}>
                            Setup
                        </Title>
                    </Row>
                    <div
                        style={{
                            height: '30px',
                            width: '30px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={() => navigate(-1)}
                    >
                        <BackIcon />
                    </div>
                </Row>

                {/* Settings Cards */}
                <Row
                    style={{
                        columnGap: '20px',
                    }}
                >
                    {checkSettingModule(
                        userProfile?.role?.roleName,
                        userProfile?.currentWorkSpace?.domain
                    ).map((data) => {
                        return (
                            <>
                                <Card
                                    styles={{
                                        body: {
                                            padding: '25px 40px',
                                        },
                                    }}
                                    key={data?.label}
                                    style={{
                                        cursor: 'pointer',
                                        width: '200px',
                                        borderRadius: '16px',
                                    }}
                                    onClick={() => navigate(data?.navigate)}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Image
                                            src={data?.icon}
                                            preview={false}
                                            height={54}
                                            width={54}
                                        />
                                        <div
                                            style={{
                                                marginTop: '10px',
                                            }}
                                        >
                                            <Title level={4}>
                                                {data?.label}
                                            </Title>
                                        </div>
                                    </div>
                                </Card>
                            </>
                        )
                    })}
                </Row>
            </Content>
            <DeletePopUp
                previewDelete={state?.deleteModal}
                onDelete={() => {
                    setState({ ...state, deleteButtonLoading: true })
                    logOut()
                }}
                loadingButton={state?.deleteButtonLoading}
                onCancel={() => {
                    setState({
                        ...state,
                        deleteButtonLoading: false,
                        deleteModal: false,
                    })
                }}
                modalTitle="Log Out"
                keyModal="logout"
            />
        </Layout>
    )
}

export default GlobalSetting
